import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import {Link} from "react-router-dom";
import moment from "moment/moment";
import Loading from "../../components/loading";
import {useTranslation} from "react-i18next";
import stringHelper from "../../helpers/string-helper";
import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";
import NoData from "../../components/no-data";
import PromotionCategories from "./categories";


const types = ['all', 'active', 'expired'];
const Promotions = () => {

    const {promotionsR} = useSelector(state => state.dataReducer)
    const {activeLanguage} = useSelector(state => state.globalReducer)
    const {i18n, t} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [loading, setLoading] = useState(false)
    const [activeType, setActiveType] = useState('all')
    const [data, setData] = useState([])

    useEffect(() => {
        if (!loading && activeLanguage?.key && (!promotionsR || !promotionsR[`${activeLanguage?.key}|${activeType}`])) {
            setLoading(true)
            associateServices.getPromotionList({
                lang: activeLanguage.key,
                type: activeType
            }).then(res => {
                // setData(res?.data)
                store.dispatch(DataActions.setPromotions({
                    type: `${activeLanguage?.key}|${activeType}`,
                    data: res?.data
                }))
                setLoading(false)

            })
        }
    }, [activeLanguage?.key, activeType, promotionsR, loading])

    useEffect(() => {
        try {
            setData(promotionsR[`${activeLanguage?.key}|${activeType}`])
        } catch (e) {

        }
    }, [promotionsR, activeType, activeLanguage?.key])

    return (
        <div className="section">


            <div className="container">

                <div className="row">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h1 className="section__title section__title--head">{t('promotions.title')}</h1>

                        <ul
                            className="nav nav-tabs tabs-nav"
                            id="tabs-nav"
                            role="tablist"
                        >

                            {
                                types?.map(type => (
                                    <li className="nav-item" role="presentation" key={type}>
                                        <button
                                            onClick={e => setActiveType(type)}
                                            className={`tabs-nav__btn ${activeType === type ? 'active' : ''}`}
                                            type="button">
                                            {t(`promotions.${type}`)}
                                        </button>
                                    </li>
                                ))
                            }

                        </ul>
                    </div>


                </div>

                <PromotionCategories activeType={activeType}/>
                {/*<div className="row">*/}
                {/*    {*/}
                {/*        loading ? <Loading/> :*/}
                {/*            data?.length <= 1 ? <NoData desc={t('promotions.empty', '')}/> :*/}
                {/*                data?.map(promotion => (*/}
                {/*                    <div className="col-12 col-md-6 col-xxl-4" key={promotion.image}>*/}
                {/*                        <div className="promo-post promo-post--grid">*/}
                {/*                            <Link*/}
                {/*                                to={stringHelper.getLocalizedPath(currentLanguage, `/promotion/${promotion.slug}`)}*/}
                {/*                                className="promo-post__cover">*/}
                {/*                                <LazyLoadImage*/}
                {/*                                    height={'100%'}*/}
                {/*                                    width={'100%'}*/}
                {/*                                    effect="blur"*/}
                {/*                                    placeholderSrc={promotion.image}*/}
                {/*                                    src={promotion.image}*/}
                {/*                                    alt={promotion.title}/>*/}
                {/*                            </Link>*/}
                {/*                            <div className="promo-post__content">*/}
                {/*                        <span className="promo-post__date">*/}
                {/*                            {moment.unix(promotion.timestamp).format('MMM Do YY')}*/}
                {/*                        </span>*/}
                {/*                                <h3 className="promo-post__title one-line-ellipsis">*/}
                {/*                                    {promotion.title}*/}
                {/*                                </h3>*/}
                {/*                                <p className="promo-post__text one-line-ellipsis">*/}
                {/*                                    {promotion.description}*/}
                {/*                                </p>*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                ))*/}
                {/*    }*/}
                {/*</div>*/}

            </div>
        </div>

    )

}

export default Promotions
